import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { messagingDiagnosticsCampaignsForFilter } from "./constants";
import type { MessagingDiagnosticsCampaignFilterResult } from "./types";

export const getMessagingDiagnosticsCampaignsForFilter = reactQueryFetcherAdapter(
  messagingDiagnosticsCampaignsForFilter,
  (
    signal: AbortSignal,
    appGroupId: string,
    query: string,
    limit: number,
    // Empty string means "omit"; the adapter cache-key type excludes `undefined`.
    windowStart: string
  ): Promise<MessagingDiagnosticsCampaignFilterResult[]> => {
    return fetch(
      `/${appGroupId}/messaging_diagnostics/campaigns_for_filter`,
      "GET",
      {
        query,
        limit,
        ...(windowStart ? { window_start: windowStart } : {}),
      },
      { signal }
    );
  }
);
